<template>
  <div class="missions__challenge">
    <div class="missions__challenge__top">
      <div class="missions__challenge__label">
        <span>{{ $t("missions.challenge.name") }}</span>
      </div>
      <InfoTooltip :tooltipName="'challenge'" :tooltipAdditionalTheme="'wf-bp'">
        <template v-slot:tooltip_title>{{ $t("missions.challenge.tooltip") }}</template>
        <p v-html="getTooltipText"></p>
      </InfoTooltip>
    </div>
    <div class="mission__label">{{ $t("missions.challenge.description") }}</div>

    <div class="mission__text" :class="{ 'mission__text--complete': missionComplete }">
      {{ getMissionPersonal.title }}
    </div>

    <div class="mission__progress">
      <div class="mission__progress__header">
        <template v-if="!missionComplete">
          <div class="mission__label">{{ $t("missions.challenge.progress") }}</div>
          <span>{{ getMissionProgress }}/{{ getMissionPersonal.target_count }}</span>
        </template>
        <span v-else>{{ $t("missions.challenge.done") }}</span>
      </div>
      <ProgressLine :current="getProgressWidth" />
    </div>

    <div class="mission__reward">
      <div
        v-for="reward_item in getMissionPersonal.rewards"
        :key="reward_item.reward.currency"
        class="mission__reward__item"
      >
        <i :class="getCurrencyIconClass(reward_item.reward.currency)"></i>
        <span>{{ reward_item.reward.count }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressLine from "@/components/Common/ProgressLine";
import InfoTooltip from "@/components/Common/InfoTooltip";
import { mapGetters } from "vuex";

export default {
  name: "MissionsChallenge",

  components: {
    ProgressLine,
    InfoTooltip,
  },

  computed: {
    ...mapGetters("missions", ["getMissionPersonal"]),

    getProgressWidth() {
      return (this.getMissionProgress / this.getMissionPersonal.target_count) * 100;
    },

    getMissionProgress() {
      let progress = this.getMissionPersonal.progress,
        target_count = this.getMissionPersonal.target_count;

      return progress >= target_count ? target_count : progress;
    },

    missionComplete() {
      return this.getMissionPersonal.is_complete;
    },

    getTooltipText() {
      return this.$t("missions.warning");
    },
  },

  methods: {
    getCurrencyIconClass(currency) {
      let class_string = "icon ";

      class_string += currency === "hard" ? "icon-paid-points" : "icon-free-points";
      return class_string;
    },
  },
};
</script>
